import { render, staticRenderFns } from "./sidebar-navigation.vue?vue&type=template&id=7125c962&scoped=true&"
import script from "./sidebar-navigation.vue?vue&type=script&lang=js&"
export * from "./sidebar-navigation.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-navigation.vue?vue&type=style&index=0&id=7125c962&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7125c962",
  null
  
)

/* custom blocks */
import block0 from "./sidebar-navigation.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports